import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/ai-worker-removebg.png";

const Navbar = () => {
  const navigate = useNavigate();
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="bg-white/80 backdrop-blur-md relative z-50 border-b border-slate-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <img
              src={logo}
              alt="Logo"
              width={180}
              height={40}
              className="object-contain cursor-pointer"
              onClick={() => handleScroll("hero")}
            />
          </div>
        </div>

        {/* Desktop Navigation Links */}
        <div className="hidden md:flex items-center space-x-8 text-slate-600 font-medium">
          <button
            onClick={() => handleScroll("benefits")}
            className="hover:text-cyan-500 transition-colors"
          >
            Who It's For
          </button>
          <button
            onClick={() => handleScroll("how-it-works")}
            className="hover:text-cyan-500 transition-colors"
          >
            How It Works
          </button>
          <button
            onClick={() => handleScroll("pricing")}
            className="hover:text-cyan-500 transition-colors"
          >
            Pricing Plans
          </button>
          <button
            onClick={() => handleScroll("about")}
            className="hover:text-cyan-500 transition-colors"
          >
            About Us
          </button>
          <button
            onClick={() => handleScroll("contact-us")}
            className="hover:text-cyan-500 transition-colors"
          >
            Contact Us
          </button>
        </div>

        {/* Sign Up Button */}
        <div className="hidden md:flex items-center space-x-6">
          <button
            onClick={() => navigate("/signup")}
            className="bg-white text-blue-600 text-sm font-semibold py-2 px-5 rounded-full border border-blue-200 hover:bg-blue-50 transition-colors shadow-sm"
          >
            Sign Up
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
